// extracted by mini-css-extract-plugin
export var outerContainer = "Marquee-module--outer-container--9Xn3f";
export var innerContainer = "Marquee-module--inner-container--ESb9g";
export var scrollContainer = "Marquee-module--scroll-container--dRipw";
export var scrollButton = "Marquee-module--scroll-button--uG9Xs";
export var scrollButtonLeft = "Marquee-module--scroll-button-left--MeXGF";
export var scrollButtonRight = "Marquee-module--scroll-button-right--EoxS5";